import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export interface NavRailButtonProps {
  title: string;
  onClick: () => void;
  icon: IconProp;
}

export const NavRailButton = ({ title, onClick, icon }: NavRailButtonProps) => {
  return (
    <Tooltip title={title} placement={"left"} PopperProps={{ style: { zIndex: 500 } }}>
      <IconButton
        onClick={onClick}
        sx={[
          {
            "&:hover": { borderRadius: 0, width: "56px", height: "56px" },
            width: "56px",
            height: "56px",
          },
        ]}
      >
        <span className="fa-layers fa-fw">
          <FontAwesomeIcon icon={icon} size="sm" />
        </span>
      </IconButton>
    </Tooltip>
  );
};
